export default __webpack_public_path__ + "static/media/payroll-details.82758089.svg";